import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { maybeAddCTATile } from "@faire/retailer-visitor-shared/components/Carousel/CTATile";
import { ScrollWrapper } from "@faire/retailer-visitor-shared/components/Scroll/ScrollWrapper";
import { debounceIfPossible } from "@faire/web--source/common/globals/debounceIfPossible";
import { Spacer } from "@faire/web--source/slate/spacing";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React from "react";
import styled, { css } from "styled-components";
var SCROLL_THROTTLE = 500;
export var Content = styled.div.withConfig({
    componentId: "sc-d9130b65-0"
})([
    "display:flex;flex-direction:row;",
    ""
], function(param) {
    var $lateralPadding = param.$lateralPadding, $itemGap = param.$itemGap;
    return css([
        "padding:0 ",
        "px;gap:",
        "px;"
    ], $lateralPadding, $itemGap);
});
var ContentItem = styled.div.withConfig({
    componentId: "sc-d9130b65-1"
})([
    "",
    " min-width:",
    ";flex-shrink:0;"
], function(param) {
    var $itemsPerSlide = param.$itemsPerSlide, $itemGap = param.$itemGap, $peekGapPercent = param.$peekGapPercent;
    return css([
        "width:calc( ((100vw - ",
        "%) / ",
        ") - ",
        "px );"
    ], $peekGapPercent, $itemsPerSlide, $itemGap);
}, function(param) {
    var $minWidth = param.$minWidth;
    return $minWidth !== null && $minWidth !== void 0 ? $minWidth : "unset";
});
export var HorizontalScrollCarousel = function(param) {
    var ctaTileData = param.ctaTileData, itemsFromProps = param.items, itemsPerSlide = param.itemsPerSlide, renderItem = param.renderItem, _param_itemGap = param.itemGap, itemGap = _param_itemGap === void 0 ? 20 : _param_itemGap, _param_peekGapPercent = param.peekGapPercent, peekGapPercent = _param_peekGapPercent === void 0 ? 10 : _param_peekGapPercent, _param_lateralPadding = param.lateralPadding, lateralPadding = _param_lateralPadding === void 0 ? 20 : _param_lateralPadding, onScroll = param.onScroll, dataTestId = param.dataTestId, onScrollEnd = param.onScrollEnd;
    var items = maybeAddCTATile(itemsFromProps, ctaTileData, itemsPerSlide);
    var isMobile = useViewport().isMobile;
    var _React_useState = _sliced_to_array(React.useState({
        start: 0,
        end: itemsPerSlide
    }), 2), state = _React_useState[0], setState = _React_useState[1];
    var wrapperRef = /*#__PURE__*/ React.createRef();
    var onHorizontalScrollRef = React.useRef(undefined);
    React.useEffect(function() {
        onHorizontalScrollRef.current = debounceIfPossible(function() {
            var _wrapperRef_current, _wrapperRef_current1;
            var scrollWidth = (_wrapperRef_current = wrapperRef.current) === null || _wrapperRef_current === void 0 ? void 0 : _wrapperRef_current.scrollWidth;
            var scrollLeft = (_wrapperRef_current1 = wrapperRef.current) === null || _wrapperRef_current1 === void 0 ? void 0 : _wrapperRef_current1.scrollLeft;
            if (onScroll && scrollWidth !== undefined && scrollLeft !== undefined) {
                var itemWidthWithGap = scrollWidth / items.length;
                var start = Math.floor((scrollLeft + itemWidthWithGap / 2) / itemWidthWithGap);
                var end = start + itemsPerSlide;
                if (start !== state.start && end !== state.end) {
                    onScroll(start, end);
                    setState({
                        start: start,
                        end: end
                    });
                }
                if (end === items.length) {
                    onScrollEnd === null || onScrollEnd === void 0 ? void 0 : onScrollEnd();
                }
            }
        }, SCROLL_THROTTLE);
        return function() {
            if (onHorizontalScrollRef.current && "cancel" in onHorizontalScrollRef.current) {
                var _onHorizontalScrollRef_current;
                (_onHorizontalScrollRef_current = onHorizontalScrollRef.current) === null || _onHorizontalScrollRef_current === void 0 ? void 0 : _onHorizontalScrollRef_current.cancel();
            }
        };
    }, [
        items.length,
        itemsPerSlide,
        onScroll,
        onScrollEnd,
        state.end,
        state.start,
        wrapperRef
    ]);
    var getTileMinWidth = function(item) {
        if (isMobile && (item === null || item === void 0 ? void 0 : item.icon_text_tile) !== undefined) {
            return "232px";
        }
        return undefined;
    };
    var renderContentItem = function(item, index) {
        return /*#__PURE__*/ _jsx(ContentItem, {
            $itemGap: itemGap,
            $itemsPerSlide: itemsPerSlide,
            $peekGapPercent: peekGapPercent,
            $minWidth: getTileMinWidth(item),
            children: /*#__PURE__*/ React.isValidElement(item) ? item : renderItem(item, index)
        }, index);
    };
    return /*#__PURE__*/ _jsx(ScrollWrapper, {
        "data-test-id": dataTestId,
        $horizontal: true,
        $hideScrollBar: true,
        ref: wrapperRef,
        onScroll: function() {
            var _onHorizontalScrollRef_current;
            return (_onHorizontalScrollRef_current = onHorizontalScrollRef.current) === null || _onHorizontalScrollRef_current === void 0 ? void 0 : _onHorizontalScrollRef_current.call(onHorizontalScrollRef);
        },
        children: /*#__PURE__*/ _jsxs(Content, {
            $itemGap: itemGap,
            $lateralPadding: lateralPadding,
            children: [
                items.map(renderContentItem),
                /*#__PURE__*/ _jsx(Spacer, {
                    size: lateralPadding - itemGap
                })
            ]
        })
    });
};
HorizontalScrollCarousel.Item = ContentItem;
HorizontalScrollCarousel.ItemWrapper = Content;
